var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flexible-product"},[_c('product-banner',{attrs:{"type":"flexible"}}),_c('product-detail',{attrs:{"type":"flexible"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }